import React from "react";
import { StoreCard } from "../../../lib/types/detailsTypes";
import { Box, Typography, LinearProgress } from "@mui/material";

interface PointProgramRowProps {
  card: StoreCard;
  onClick: () => void;
}

const PointCardStrip: React.FC<PointProgramRowProps> = ({ card, onClick }) => {
  // Assuming points data is available in the card
  const currentPoints = card.balance || 0;
  const pointsRequired = card.maxBalance || 100;
  const progress = Math.min(100, (currentPoints / pointsRequired) * 100);

  const isRewardAvailable =
    card.rewards?.some((reward) => currentPoints >= reward.balanceRequired) ||
    currentPoints >= pointsRequired;

  return (
    <Box
      onClick={onClick}
      sx={{
        width: "100%",
        px: 2,
        py: 1,
        boxSizing: "border-box",
        borderBottom: "1px solid rgba(0,0,0,.08)",
        backgroundColor: card.stampAreaBackgroundColor || "#ffffff",
        "&:hover": { backgroundColor: "rgba(0,0,0,.03)", cursor: "pointer" },
        color: card.cardTextColor || "#000",
      }}
    >
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        <Typography variant="body1" fontWeight={500}>
          <strong>{card.cardName || "Points Card"}</strong>
        </Typography>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          {isRewardAvailable && (
            <Box
              sx={{
                width: "10px",
                height: "10px",
                borderRadius: "50%",
                backgroundColor: "#ff9800",
                marginRight: "8px",
              }}
            />
          )}
          <Typography variant="body2" fontWeight={500}>
            {currentPoints} pts
          </Typography>
        </Box>
      </Box>
      <Box sx={{ display: "flex", alignItems: "center", mt: 1 }}>
        <LinearProgress
          variant="determinate"
          value={progress}
          sx={{
            flex: 1,
            height: "6px",
            borderRadius: "3px",
            backgroundColor: card.inactiveStampColor || "#e0e0e0",
            "& .MuiLinearProgress-bar": {
              backgroundColor: card.activeStampColor || "#3f51b5",
            },
          }}
        />
      </Box>
    </Box>
  );
};

export default PointCardStrip;
